import React, { useEffect } from "react";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const { NewVersionAvailableMsg } = window['runConfig'];

const VersionCheck = () => {

    const [open, setOpen] = React.useState(false);

    const ClearCache = () => {

        caches.keys().then((names) => {
            // Delete all the cache files
            names.forEach(name => {
                caches.delete(name);
            })
        });


        // Makes sure the page reloads. Changes are only visible after you refresh.
        window.location.reload(true);
    }


    const handleClose = () => {
        setOpen(false);
        ClearCache();
    };


    useEffect(() => {

        let getLatestVersionUrl = `${process.env.PUBLIC_URL}/version.js`;
        let latestVersion = '';
        let currentVersion = window['info'].version;


        try {

            if (open === false) {
                fetch(getLatestVersionUrl)
                    .then(response => {
                        return response.text().then(text => {
                            let js =

                                JSON.stringify(text.replace(" ", "")
                                    .replace("window['info']=", "")
                                    .replace("version", '"version"')
                                    .replace("\n\r", "")
                                    .replace("'", '"')
                                    .replace("'", '"'));

                            let jsonData = JSON.parse(js);
                            latestVersion = JSON.parse(jsonData).version;

                            if (latestVersion !== currentVersion) {
                                setOpen(true);
                            }
                        });
                    })
                    .catch(error => console.error(error));
            }

        } catch (error) {
            console.error(error);
        }
    })

    if (open == false) {
        return (
            <></>
        );
    }

    if (open == true) {
        return (
            <div>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    disableEscapeKeyDown={true}
                    disableBackdropClick={true}
                >
                    <DialogTitle id="alert-dialog-title">
                        {"New Version"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {NewVersionAvailableMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions >
                        <Button onClick={handleClose} variant="contained" size="medium" color="primary" alignItems="center">
                            Refresh
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
};


export default VersionCheck;